import { TypedSopNode } from "./_Base";
import { ROTATION_ORDERS, TransformTargetType, TRANSFORM_TARGET_TYPES } from "../../../core/Transform";
import { TransformSopOperation, TRANSFORM_OBJECT_MODES } from "../../operations/sop/Transform";
import { NodeParamsConfig, ParamConfig } from "../utils/params/ParamsConfig";
import { SopType } from "../../poly/registers/nodes/types/Sop";
const DEFAULT = TransformSopOperation.DEFAULT_PARAMS;
class TransformSopParamConfig extends NodeParamsConfig {
  constructor() {
    super(...arguments);
    this.applyOn = ParamConfig.INTEGER(DEFAULT.applyOn, {
      menu: {
        entries: TRANSFORM_TARGET_TYPES.map((name, value) => {
          return { name, value };
        })
      }
    });
    this.objectMode = ParamConfig.INTEGER(DEFAULT.objectMode, {
      visibleIf: { applyOn: TRANSFORM_TARGET_TYPES.indexOf(TransformTargetType.OBJECTS) },
      menu: {
        entries: TRANSFORM_OBJECT_MODES.map((name, value) => {
          return { name, value };
        })
      }
    });
    this.group = ParamConfig.STRING(DEFAULT.group, {
      visibleIf: { applyOn: TRANSFORM_TARGET_TYPES.indexOf(TransformTargetType.GEOMETRIES) }
    });
    this.rotationOrder = ParamConfig.INTEGER(DEFAULT.rotationOrder, {
      menu: {
        entries: ROTATION_ORDERS.map((order, v) => {
          return { name: order, value: v };
        })
      }
    });
    this.t = ParamConfig.VECTOR3(DEFAULT.t);
    this.r = ParamConfig.VECTOR3(DEFAULT.r);
    this.s = ParamConfig.VECTOR3(DEFAULT.s);
    this.scale = ParamConfig.FLOAT(DEFAULT.scale, { range: [0, 10] });
    this.pivot = ParamConfig.VECTOR3(DEFAULT.pivot, {
      visibleIf: { applyOn: TRANSFORM_TARGET_TYPES.indexOf(TransformTargetType.GEOMETRIES) }
    });
  }
}
const ParamsConfig = new TransformSopParamConfig();
export class TransformSopNode extends TypedSopNode {
  constructor() {
    super(...arguments);
    this.paramsConfig = ParamsConfig;
  }
  static type() {
    return SopType.TRANSFORM;
  }
  static displayedInputNames() {
    return ["geometries or objects to transform"];
  }
  initializeNode() {
    this.io.inputs.setCount(1);
    this.io.inputs.initInputsClonedState(TransformSopOperation.INPUT_CLONED_STATE);
  }
  setApplyOn(type) {
    this.p.applyOn.set(TRANSFORM_TARGET_TYPES.indexOf(type));
  }
  setObjectMode(mode) {
    this.p.objectMode.set(TRANSFORM_OBJECT_MODES.indexOf(mode));
  }
  cook(inputCoreGroups) {
    this._operation = this._operation || new TransformSopOperation(this.scene(), this.states);
    const coreGroup = this._operation.cook(inputCoreGroups, this.pv);
    this.setCoreGroup(coreGroup);
  }
}
